import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useSearchParams from "@/hooks/useSearchParams";
import { styled } from "@mui/material";
import { useEffect } from "react";
import { AuthorProfile } from "./AuthorProfile";
import { BrandBanner } from "./BrandBanner";
import { useBrandStore } from "./BrandProvider";
export const ProfileSection = (param)=>{
    let { data  } = param;
    const searchParams = useSearchParams();
    const updateBrand = useBrandStore((state)=>state.updateBrand);
    const name = useBrandStore((state)=>state.brand.name);
    useEffect(()=>{
        if (searchParams.get("userId") !== name) {
            updateBrand(data);
        }
    }, [
        searchParams
    ]);
    return /*#__PURE__*/ _jsxs(ProfileSectionContainer, {
        children: [
            /*#__PURE__*/ _jsx(BrandBanner, {}),
            /*#__PURE__*/ _jsx(AuthorProfile, {})
        ]
    });
};
const ProfileSectionContainer = styled("section")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        textAlign: "center",
        maxWidth: "1200px",
        margin: "0 auto",
        [theme.breakpoints.down("lg")]: {
            padding: "0 32px"
        },
        [theme.breakpoints.down("sm")]: {
            padding: "0"
        }
    };
});
